import heliosBreakpoints, {
  legacyBreakpoints
} from '@carvana/merch-tailwind/breakpoints';

export type BreakpointSizes = {
  mobile: number;
  desktop: number;
  largeDesktop?: number;
};

export const legacySizes: BreakpointSizes = {
  mobile: legacyBreakpoints.m,
  desktop: legacyBreakpoints.l
};

export const heliosSizes = {
  mobile: heliosBreakpoints.sm,
  desktop: heliosBreakpoints.md,
  largeDesktop: heliosBreakpoints.lg
};
